import {List} from 'antd'
import {getType} from 'apis/model/base'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {async_schema, EnitityManager, useManager,} from 'views/AppLocals/factory/createEntityManager'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../envs/_current/history";

const renderDefaultItem =
    ({renderContextMenu = NullAsDefault}) =>
        (item, index) =>
            (
                <Translate key={index}>
                    {(t) => (
                        <div className="p-2 border rounded-lg gap-2 relative">
                            <List.Item.Meta
                                title={getTitle(item)}
                                description={getType(item)}
                            />
                            {renderContextMenu(item)}
                        </div>
                    )}
                </Translate>
            )

const SubCategoriesContainer = ({
                                    title,
                                    configs,
                                    owner_id,
                                    owner_type,
                                    createFormSchema,
                                    fetchItems = async_schema,
                                    renderItem = renderDefaultItem,
                                    filter_actions = {
                                        // type: 'type',
                                        sortBy: 'sort-by',
                                        keyword: 'keyword',
                                    },
                                }) => {
    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const {
        refreshKey,
        modal = null,
        renderContextMenu,
        handleAction = NullAsDefault,
    } = useManager({
        configs,
        params: {
            owner_id,
            owner_type,
        },
        createFormSchema,
    })

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        onInit: ({
                     onSortChange = NullAsDefault,
                     // onFilterChange = NullAsDefault,
                 }) => {
            // onFilterChange({
            //   type,
            // })
            onSortChange(sortBy)
        },
        pagerInfo: {
            ...(fetchItems || {}),
            RenderEntity: React.Fragment,
            renderItem: renderItem({
                renderContextMenu,
            }),
        },
        withKey: createPagerKey([
            JSON.stringify({
                meta: fetchItems,
            }),
            refreshKey,
        ]),
        query_params: filter_actions,
    })

    return (
        <EnitityManager
            {...{
                modal,
                title,
                handleAction,
            }}>
            {pager_widget}
        </EnitityManager>
    )
}

export default SubCategoriesContainer
